import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import Button from "../../../../components/buttons/button";
import {
  useAddPlaylistMutation,
  useUpdatePlaylistMutation,
  useGetPlaylistQuery,
} from "../../../../store/Reducer/playlist";
import toast from "react-hot-toast";

export default function AttachPlayList({ isOpen, closeModal, deviceId }) {
  const { t } = useTranslation();
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);

  const [updatePlaylist, { isLoading: updatePlaylistLoading }] =
    useUpdatePlaylistMutation();
  const { data, isLoading } = useGetPlaylistQuery({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedPlaylist) {
      toast.error("Please select a playlist.");
      return;
    }

    try {
      const displayData = {
        deviceId: deviceId,
        themeColor: selectedPlaylist.themeColor,
        itemsToDisplay: selectedPlaylist.itemsToDisplay,
        id: selectedPlaylist?._id 

      };

      await updatePlaylist(displayData).unwrap();
      toast.success("Playlist updated successfully!");
      closeModal(); // Close the modal after successful submission
    } catch (error) {
      console.log("Error submitting form:", error);
      toast.error(error?.data?.message || "An error occurred!");
    }
  };

  useEffect(() => {
    if (isOpen) {
      // Reset selected playlist when the modal opens
      setSelectedPlaylist(null);
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 overflow-y-auto bg-black bg-opacity-70 flex items-center justify-center z-50 mt-0 p-4 sm:p-0"
          onClick={closeModal}
        >
          <div
            className="rounded-lg shadow-xl w-full max-w-lg mx-auto h-full sm:h-auto sm:max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mx-auto w-full bg-white rounded-lg shadow-lg p-4 sm:px-6 sm:py-6">
              <div>
                <h1 className="text-2xl font-semibold text-gray-900 mb-6">
                  {"Attach Playlist"}
                </h1>

                {(isLoading || updatePlaylistLoading) && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="loader border-t-4 border-blue-500 rounded-full w-16 h-16 animate-spin"></div>
                    <p className="text-white mt-4">Loading...</p>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="space-y-4">
                    {/* Display playlist options */}
                    <div className="space-y-3">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Select Playlist
                      </label>
                      {data?.data?.map((playlist) => (
                        <div
                          key={playlist._id}
                          className="flex items-center cursor-pointer"
                          onClick={() => setSelectedPlaylist(playlist)}
                        >
                          <input
                            type="radio"
                            name="playlist"
                            checked={selectedPlaylist?._id === playlist?._id}
                            onChange={() => setSelectedPlaylist(playlist)}
                            className="w-5 h-5 text-blue-600"
                          />
                          <span className="ml-2 text-gray-700">
                            {playlist.name || playlist.themeColor}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex justify-center sm:justify-end items-center flex-wrap space-x-3 pt-4">
                    <button
                      type="button"
                      onClick={closeModal}
                      className="px-4 py-2 rounded-lg font-semibold text-sm transition-colors duration-200 ease-in-out focus:outline-none flex items-center text-gray-800 border border-gray-700 hover:bg-gray-100 justify-center"
                    >
                      {t("universal_cancel_text")}
                    </button>

                    <Button
                      text={t("universal_save_text")}
                      type="submit"
                      className="px-6 text-nowrap"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
